import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/housekeeping/useHousekeepingQueryKeys.ts
var t = e("housekeeping", {
	board: (e, t) => e ? t ? [
		"board",
		e,
		t
	] : ["board", e] : ["board"],
	attention: (e) => e ? ["attention", e] : ["attention"],
	settings: () => ["settings"]
});
//#endregion
export { t as housekeepingQueryKeys };
